import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {PatientSmall} from '@/features/patients/types'
import {httpGetProjectsByPatientDate, ProjectByPatientDateResponse} from '../http/projects.http'

export const useGetProjectsByPatientDate = ({
    patientId,
    date,
    options
}: {
    patientId: PatientSmall['id']
    date: string
    options?: Omit<UseQueryOptions<ProjectByPatientDateResponse['extended']>, 'queryKey' | 'queryFn'>
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECTS_BY_PATIENT, patientId, date],
        queryFn: () => httpGetProjectsByPatientDate({urlParams: {patientId}, params: {date, responseType: 'extended'}}),
        ...options
    })
